import React from 'react';
import { Avatar, Divider, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, Tooltip, Typography } from '@mui/material';
import InboxIcon from '@mui/icons-material/Inbox';
import { EmptyState } from '../../../../components/empty-state';
import { stringAvatar } from '../../../../utils/avatar';

export interface RecentItem {
    id: number;
    avatarName: string;
    title?: string;
    highlight?: string;
    caption?: string;
}

// Lista das últimas remessas/edições do painel, com estado vazio
export function RecentItemsList({ items, emptyMessage, onSelect }: { items: RecentItem[]; emptyMessage: string; onSelect: (id: number) => void }) {
    if (items.length === 0) {
        return <EmptyState icon={<InboxIcon />} message={emptyMessage} />;
    }

    return (
        <List sx={{ width: '100%', bgcolor: 'background.paper' }} disablePadding>
            {items.map((item, index) => (
                <React.Fragment key={item.id}>
                    <ListItem alignItems="flex-start" disablePadding>
                        <ListItemButton onClick={() => onSelect(item.id)}>
                            <ListItemAvatar>
                                <Tooltip title={item.avatarName}>
                                    <Avatar {...stringAvatar(item.avatarName)} alt={item.avatarName} />
                                </Tooltip>
                            </ListItemAvatar>
                            <ListItemText
                                primary={item.title}
                                secondary={
                                    <React.Fragment>
                                        <Typography sx={{ display: 'inline' }} component="span" variant="body2" color="text.primary">
                                            {item.highlight}
                                        </Typography>
                                        {item.caption && ` ${item.caption}`}
                                    </React.Fragment>
                                }
                            />
                        </ListItemButton>
                    </ListItem>
                    {index < items.length - 1 && <Divider variant="inset" component="li" />}
                </React.Fragment>
            ))}
        </List>
    );
}
